import { get } from 'lodash'
import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ITicketDetails } from '@api/types'
import { TicketDetailsFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createTicket: { ticket: ITicketDetails }
}

const mutateHandler = handleFetchResult<IPayload, ITicketDetails>({
  handler: (data) => data.createTicket.ticket,
  name: 'Ticket Details',
})

export type FormTicket = Omit<
  ITicketDetails,
  'id' | 'ticketNumber' | 'externalUrl' | 'employee' | 'source' | 'createdDate'
>

export default function create(ticket: FormTicket): Promise<ITicketDetails> {
  const input = {
    status: ticket.status,
    severity: ticket.severity,
    shortDescription: ticket.shortDescription,
    description: ticket.description,
    dueDate: ticket.dueDate,
    assignedToId: get(ticket, 'assignedTo.id'),
    buildingId: get(ticket, 'building.id'),
    floorPlanId: get(ticket, 'floor_plan.id'),
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation createTicket($input: CreateTicketInput!) {
    createTicket(input: $input) {
      ticket {
        ...TicketDetailsFragment
      }
    }
  }
  ${TicketDetailsFragment}
`
